export default "__VITE_ASSET__Cg14Rzh2__"